import { useEffect, useState } from "react";

import { ClipboardItemType } from "@pages/Templates/constants";

export type TemplateClipboardItem =
  | { type: typeof ClipboardItemType.SECTION; id: number; title: string }
  | { type: typeof ClipboardItemType.FIELD; id: number; title: string };

let _item: TemplateClipboardItem | null = null;
const _listeners = new Set<() => void>();

const notify = () => _listeners.forEach((fn) => fn());

const clipboardStore = {
  get: () => _item,
  set: (item: TemplateClipboardItem | null) => {
    _item = item;
    notify();
  },
};

export function useTemplateClipboard() {
  const [item, setItem] = useState<TemplateClipboardItem | null>(_item);

  useEffect(() => {
    const refresh = () => setItem(clipboardStore.get());
    _listeners.add(refresh);
    return () => {
      _listeners.delete(refresh);
    };
  }, []);

  return { item, copy: clipboardStore.set };
}
